var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCompassFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "e/icon/map/compass_fill"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2ZM16.2427 7.75734C15.8891 7.40379 11.2929 8.46445 9.87873 9.87866C8.46452 11.2929 7.40386 15.8891 7.75741 16.2426C8.11097 16.5962 12.7072 15.5355 14.1214 14.1213C15.5356 12.7071 16.5962 8.1109 16.2427 7.75734ZM12 11C12.5523 11 13 11.4477 13 12C13 12.5523 12.5523 13 12 13C11.4477 13 11 12.5523 11 12C11 11.4477 11.4477 11 12 11Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompassFill);
export default __webpack_public_path__ + "static/media/compass_fill.22b3cb4959db3fe443491423fdef353b.svg";
export { ForwardRef as ReactComponent };